var handle_array = ["tretinoin-0-1","silagen","3-product-bundle-silicone-gel-for-scars","smart-tone-broad-spectrum-spf-50","anti-aging-program","correct-conceal-light","zo-daily-power-defense-1-7-fl-oz-50ml","daily-sheer-broad-spectrum-spf-50","exfoliating-polish","gentle-cleanser","growth-factor-serum","instant-pore-refiner","oil-control-pads","multi-therapy","recovery-creme","rozatrol","sulfur-masque","sunscreen-primer","a-g-e-interrupter","biocellulose-mask","ce-ferulic","hydrating-b5-gel","skinceuticals-lha-cleanser-gel","sheer-physical-fusion-uv","physical-fusion-uv-defense","triple-lipid-2-4-2","alpharet-intensive-overnight-face","alpharet-overnight-face","alto-defense-face","even-tone-correcting-serum-face","hydrating-boosting-cream","instant-effect-gel-eye","interfuse-lines","interfuse-tx-eye","smoothing-interfuse-treatment-cream-face-30ml","bs-trio-rebalancing-moisture-treatment-by-skinbetter-science"];
 var productid_array = ["1902687420505","4503878795363","1902690861145","4503563337827","4753305469027","1902703312985","1902697906265","1902705606745","1902625882201","1902617493593","1902630862937","1902635352153","1902637580377","1902663139417","1902653538393","1902667759705","4503559209059","4627398951011"];
 var collectionid_array = [""];
 var product_tags_array = [""];
 var hide_price=1;
 var hide_ajaxaddtocart=1;
 var display_phone=0;
 var phone_no = '+568932564789';
 var display_call_for_price = 1;
 var call_for_price_label = 'Call The Office To Order';
 var css_style_button='background-color: #000000;color:#ffffff;';
 var enabled_captcha = 0;
 var site_key = '';
 var recaptcha_ver = 'v2';
 var thankyou_msg = 'Your Request Submitted Successfully.';
 var thankyou_header = 'Success';
 var name_label='Name';
 var email_label='Email';
 var phone_label = ' Phone Number';
 var comment_label = 'Comment';
 var submit_label ='Submit';
  var error_name_label='Please fill out this field.';
 var error_email_label='Please fill out this field.';
 var error_phone_label = 'Please fill out this field.';
 var error_comment_label = 'Please fill out this field.';
 var enable_app =1;
  var enable_outofstock = 1;
 var price_selector='.product__price';
 var cart_selector='#AddToCart-product-template';
 var phone_no_label = 'Call for Price:';
 var required_field='name,email,comment';
 var contact_form_heading='Call for Price for';
 var parent_selector='';
 var unavailable_label='Unavailable';
 var show_price='no';
 var enable_cfp_for_zero_price_prd='no';
 var enable_cfp_for_all_products='no';
 var enable_cfp_soldout_products='no';
 var hide_cfp_btn_on_collection='no';
 var hide_phone_no_on_collection='no';
 var enable_whatsapp = 0;
 var whatsapp_number = '';
 var whatsapp_message = '';
 var hide_whatsapp_button_on_collection = 0;
 var whatsapp_button_text ='';
 var whatsapp_button_background_color ='#000000';
 var whatsapp_button_text_color ='#ffffff';
 var whatsapp_css_style_button ='';
 var phoneno_css_style_button ='';